<template>
  <span class="pi-ai-text"><template v-for="segment in segments"><strong v-if="segment.strong" :key="segment.key">{{ segment.text }}</strong><code v-else-if="segment.code" :key="segment.key" class="pi-ai-text__code">{{ segment.text }}</code><span v-else :key="segment.key">{{ segment.text }}</span></template></span>
</template>

<script>
import { inlineSegments } from "./piAssistantModel.js";

export default {
  name: "pi-assistant-text",
  props: {
    text: { type: String, default: "" },
  },
  computed: {
    segments() {
      return inlineSegments(this.text);
    },
  },
};
</script>

<style scoped>
.pi-ai-text {
  white-space: pre-line;
}

.pi-ai-text__code {
  padding: 0 3px;
  border-radius: 3px;
  background: #f1f2f4;
  color: #1f2933;
  font-size: 0.95em;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piAssistantText.vue